<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="center">Copyright © 1991 by Palomar S.r.l.</p>
<p class="center">Translation copyright © 1999 by Jonathan Cape</p>
<p class="center"><span class="small">ALL RIGHTS RESERVED</span></p>
<p class="center">For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.</p>
<p class="center"><a class="pubhlink" href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<p class="center">First published in Italy as <em>Perché leggere i classici</em> by Arnoldo Mondadori Editore, 1991</p>
<p class="center">This translation first published in the United Kingdom by Jonathan Cape, London, and subsequently in the United States by Pantheon Books, a division of Penguin Random House, in 1999. First published in paperback by Vintage Books, a division of Penguin Random House, in 2000.</p>
<p class="center"><em>Library of Congress Cataloging-in-Publication Data is available.</em></p>
<p class="center">ISBN: 978-0-544-14637-2</p>
<p class="center">eISBN: 978-0-544-23086-6<br/>v1.1214</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Calv_9780307549310_epub_cop_r1.vue?1ccc107e